// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialEmployee = () => {
  const item = window.sessionStorage.getItem("employee");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const getEmployee = createAsyncThunk(
  "employee/getEmployee",
  async (obj, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_HR_API}employee`, {
        params: { branch: obj.branch },
        headers: { Authorization: `Bearer ${obj.token}` },
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const employeeSlice = createSlice({
  name: "employee",
  initialState: {
    employeeData: initialEmployee(),
  },

  extraReducers: (builder) => {
    builder
      .addCase(getEmployee.fulfilled, (state, action) => {
        state.employeeData = action.payload;
        sessionStorage.setItem("employee", JSON.stringify(action.payload));
        // state.bookmarks = action.payload.bookmarks
      })
      .addCase(getEmployee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Store error message
      });
  },
});

export default employeeSlice.reducer;
